import React, { useState } from "react";
import configData from "../../../config.json";

const BydSealion7Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedColor, setSelectedColor] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737014896975.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737014991205.webp`,
      text: <span style={{ color: "rgb(39, 49, 112)" }}>Atlantis Gray</span>,
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737015048828.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737015102293.webp`,
      text: "Cosmos Black",
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737015147811.png`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737015194624.webp`,
      text: <span style={{ color: "rgb(77, 117, 157)" }}>Aurora White</span>,
    },
    {
      image: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737525327022.webp`,
      backgroundImage: `${configData.IMAGE_BASE_URL}uploads/image-upload-1737015304994.webp`,
      text: <span style={{ color: "rgb(90, 90, 90)" }}>Shark Gray</span>,
    },
  ];

  const colors = ["#273651", "#1C1F22", "#C6CED9", "#57595B"];

  const changeSlide = (index) => {
    setCurrentSlide(index);
    setActiveIndex(index);
    setSelectedColor(index);
  };
  return (
    <>
      <br></br>
      <br></br>
      <section className="fluid colorSection">
        <div className="slider-container">
          <div className="slider">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`slide ${activeIndex === index ? "active" : ""}`}
                style={{ backgroundImage: `url(${slide.backgroundImage})` }}
              >
                <div className="text">{slide.text}</div>
                <img
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                  className="slide-image"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="input-container">
          {colors.map((color, index) => (
            <div
              key={index}
              className="color-button"
              style={{
                backgroundColor: color,
                border: index === selectedColor ? "2px solid black" : "none",
              }}
              onClick={() => changeSlide(index)}
            ></div>
          ))}
        </div>
      </section>
    </>
  );
};

export default BydSealion7Slider;
